import React from 'react';
import InquiryStatusChanger from './components/InquiryStatusChanger';
import InquiryStatusFilter from './components/InquiryStatusFilter';
import LookupAutocomplete from '../../../../Components/Controls/LookupAutocomplete/LookupAutocomplete';
import SourceOfLeadChanger from './components/SourceOfLeadChanger';
import { Link } from 'react-router-dom';
import { ClientsTrackingPermissions } from "../../../../Permissions";  
import { returnPropsByPermissions } from '../../../../Helper' ; 
 
const headerData = (onFilterChange, sideMenuIsOpenUpdate) => [
  {
    label: "Contact Name",
    input: "contactName",
    component: (row) => (
      <Link
        target="_blank"
        to={`/home/Contacts-CRM/contact-profile-edit?formType=${row.contactTypeId}&id=${row.contactId}`}
      >
        {row.contactName}
      </Link>
    ),
  },
  {
    label: "Contact ID",
    input: "contactId",
    isHiddenFilter: true,
  },
  {
    label: "Client Email",
    input: "clientEmail",
  },
  {
    label: "Phone",
    input: "clientPhone",
  },
  {
    label: "Enquiry Description",
    input: "enquiryDescription",
    isHiddenFilter: true,
  },
  {
    label: "Enquiry Date",
    input: "enquiryDate",
    isDate: true,
    dateFormat: "DD/MMM/YYYY, HH:MM",
    isHiddenFilter: true,
  },
  {
    label: "Source of Lead",
    input: "sourceOfLead",
    component: (row) =>
      returnPropsByPermissions(
        ClientsTrackingPermissions.UpdateLeadSourc.permissionsId
      ) ? (
        <SourceOfLeadChanger
          key={row.generalClientTrackingId}
          {...row}
          onUpdate={sideMenuIsOpenUpdate}
        />
      ) : undefined,
    filterComponent: () =>
      returnPropsByPermissions(
        ClientsTrackingPermissions.UpdateLeadSourc.permissionsId
      ) ? (
        <LookupAutocomplete
          lookupName={"SourceOfLead"}
          onChange={(_e, value) =>
            onFilterChange((prevFilter) => ({
              ...prevFilter,
              sourceOfLeadId: value?.lookupItemId,
            }))
          }
        />
      ) : undefined,
  },
  {
    label: "Inquiry Status",
    input: "inquiryStatus",
    component: (row) =>
      returnPropsByPermissions(
        ClientsTrackingPermissions.UpdateInquiryStatus.permissionsId
      ) ? (
        <InquiryStatusChanger
          key={row.generalClientTrackingId}
          {...row}
          onUpdate={sideMenuIsOpenUpdate}
        />
      ) : undefined,
      filterComponent: () =>
      returnPropsByPermissions(
        ClientsTrackingPermissions.UpdateInquiryStatus.permissionsId
      ) ? (
        <InquiryStatusFilter
          onChange={(value) =>
            onFilterChange((prevFilter) => ({
              ...prevFilter,
              inquiryStatus: value,
            }))
          }
        />
      ) : undefined,
  },
];

export default headerData;
